module.exports = __webpack_public_path__ + "img/石川岛.png";